import React, { useEffect, useRef, useState } from 'react';
import { useInView, motion } from 'framer-motion';
import { Metric } from '../../types/content';
interface StatCounterProps {
  metric: Metric;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
}
function formatValue(value: number, decimals: number): string {
  if (decimals > 0) {
    return value.toFixed(decimals);
  }
  return Math.round(value).toLocaleString('en-US');
}
export function StatCounter({
  metric,
  className = '',
  valueClassName = '',
  labelClassName = ''
}: StatCounterProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10% 0px'
  });
  const [display, setDisplay] = useState(0);
  const decimals = metric.decimals ?? 0;
  useEffect(() => {
    if (!isInView) return;
    const duration = 1200;
    const start = performance.now();
    let frame: number;
    const tick = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(metric.value * eased);
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      } else {
        setDisplay(metric.value);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [isInView, metric.value]);
  return <motion.div ref={ref} className={className} initial={{
    opacity: 0,
    y: 12
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.4,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-188" data-mp="1hnaqfnedc8iv">
      <div className={valueClassName} data-id="element-189" data-mp="25ar4bl0w00qa">
        {metric.prefix ?? ''}
        {formatValue(display, decimals)}
        {metric.suffix}
      </div>
      <p className={labelClassName} data-id="element-190" data-mp="21agprjz141zt">{metric.label}</p>
    </motion.div>;
}